import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import headerImg from '../images/containers/header-containers.jpg'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import ContainerVoucher from '../components/ContainerVoucher'

const ContainerVouchersScreen = props => {
  const data = props.containerVouchers

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className='left'>
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className='center'>
            <Typography className={props.classes.title}>Vales de Envases</Typography>
          </div>
          <div className='right'></div>
        </Toolbar>
      )}>
      <div className={props.classes.header}>
        <Grid container direction="column">
          <Grid item container className={props.classes.filters}>
            <Grid item xs={12} onClick={props.openContainerVouchersDateModal}>
              <Typography className={props.classes.filterName}>
                Periodo
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography
                className={props.classes.filterValue}
                dangerouslySetInnerHTML={{ __html: props.containerVouchersPeriodLabel }}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid container className={props.classes.vouchers}>
        {data &&
          data.map((containerVoucher, index) => (
            <ContainerVoucher
              key={index}
              data={containerVoucher}
            />
          ))}
      </Grid>
    </Page>
  )
}

const styles = {
  appBar: {
    background: '#1B458E'
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white'
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center'
  },
  filters: {
    padding: 7,
    background: '#4A73BA'
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
    cursor: 'pointer'
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
    cursor: 'pointer'
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle'
  },
  header: {
    backgroundImage: `url('${headerImg}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto'
  },
  vouchers: {}
}

export default withStyles(styles)(ContainerVouchersScreen)



// WEBPACK FOOTER //
// ./src/screens/ContainerVouchersScreen.js